import { Menu } from 'antd';
import styles from 'layouts/main/LayoutMain.module.scss';
import { useUserStore } from 'store/user';
import { UserBadge as UserBadgeUI } from 'ui/UserBadge';

import { ChangePasswordButton } from './components/ChangePasswordButton';
import { LogoutButton } from './components/LogoutButton';

export const UserBadge = () => {
    const username = useUserStore('user')?.name || '';

    const menuItems = [
        {
            key: 'change-password',
            label: <ChangePasswordButton />,
        },
        {
            key: 'logout',
            label: <LogoutButton />,
        },
    ];

    return (
        <UserBadgeUI username={username}>
            <Menu className={styles.menu} items={menuItems} />
        </UserBadgeUI>
    );
};
